/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Model_Settings_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Your organization decides which models are available, and you pick one per chat from that list. oneAI Standard (free, hosted in Europe) suits everyday questi..." |
*
* @param {Uno_Edu_Chat_Model_Settings_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_model_settings_chip1_answer = /** @type {((inputs?: Uno_Edu_Chat_Model_Settings_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Model_Settings_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Organisation legt fest, welche Modelle verfügbar sind, und Sie wählen pro Chat eines aus dieser Liste. oneAI Standard (kostenlos, in Europa gehostet) eignet sich für alltägliche Fragen; wählen Sie ein stärkeres Modell für anspruchsvolles Reasoning, lange Dokumente oder Bilder.")
	return /** @type {LocalizedString} */ ("Your organization decides which models are available, and you pick one per chat from that list. oneAI Standard (free, hosted in Europe) suits everyday questions; choose a stronger model for hard reasoning, long documents, or images.")
});